import { render, staticRenderFns } from "./EditAlbums.vue?vue&type=template&id=012bbd2e&scoped=true&"
import script from "./EditAlbums.vue?vue&type=script&lang=js&"
export * from "./EditAlbums.vue?vue&type=script&lang=js&"
import style0 from "./EditAlbums.vue?vue&type=style&index=0&id=012bbd2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012bbd2e",
  null
  
)

export default component.exports